document.addEventListener('DOMContentLoaded', () => {
  const article = document.querySelector('article#top');
  const SUBMISSION_THRESHOLD = 100;

  // return if not on the mug-form page
  if (!article.classList.contains('mug-form')) {
    return;
  }

  // check if all mug has been claimed
  let checkClaimedState = async () => {
    const response = await fetch('/mug-form-submission-count', { method: 'GET' });
    let submissions = await response.json();

    if (submissions.length >= SUBMISSION_THRESHOLD) {
      article.classList.remove('claim-mug');
      article.classList.add('mug-claimed');
    }
  };
  checkClaimedState();

  const stepOne = document.querySelector('article#top.mug-form .form-step .step-one');
  const stepTwo = document.querySelector('article#top.mug-form .form-step .step-two');
  const stepThree = document.querySelector('article#top.mug-form .form-step .step-three');
  const stepOneNextBtn = document.querySelector('.step-one-next-btn');
  const stepTwoNextBtn = document.querySelector('.step-two-next-btn');
  const form = document.querySelector('form#mug-form');

  // set current step of the page
  function setStep(newStep) {
    article.classList.remove('step-one');
    article.classList.remove('step-two');
    article.classList.remove('step-three');
    article.classList.add(newStep);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // click handler for when user click on the step icons
  function stepClickHandler(_event) {
    let clickedClass = this.classList[0];
    setStep(clickedClass);
  }
  stepOne.addEventListener('click', stepClickHandler);
  stepTwo.addEventListener('click', stepClickHandler);
  stepThree.addEventListener('click', stepClickHandler);

  //---------- VALIDATE STEP ONE FORM FIELDS ----------
  function validateStepOneFields() {
    let passValidation = true;
    // testing regex
    const pobRegEx = /((((p[\s\.]?)\s?[o\s][\.]?)\s?)|(post\s?office\s?)|(postal\s?)|(post\s?))((box|bin|b\.?)?\s?((num|number|no|#)\.?)?\s?\d+)/gim;
    // const addressRegEx = /[0-9]+[ |[a-zà-ú.,-]* ((highway)|(autoroute)|(north)|(nord)|(south)|(sud)|(east)|(est)|(west)|(ouest)|(avenue)|(lane)|(voie)|(ruelle)|(road)|(rue)|(route)|(drive)|(boulevard)|(circle)|(cercle)|(street)|(cer\.)|(cir\.)|(blvd\.)|(hway\.)|(st\.)|(aut\.)|(ave\.)|(ln\.)|(rd\.)|(hw\.)|(dr\.)|(a\.))([ .,-]*[a-zà-ú0-9]*)*/i;
    const cityRegEx = /^[a-zA-Z\u0080-\u024F\s\/\-\)\(\`\.\"\']+$/i;
    const zipRegEx = /^\d{5}(?:[-\s]\d{4})?$/;
    const phoneRegEx = /^(1\s*[-\/\.]?)?(\((\d{3})\)|(\d{3}))\s*[-\/\.]?\s*(\d{3})\s*[-\/\.]?\s*(\d{4})\s*(([xX]|[eE][xX][tT])\.?\s*(\d+))*$/;
    const nameRegEx = /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u01FF]+([ \-']{0,1}[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u01FF]+){0,2}[.]{0,1}$/i;
    const emailRegEx = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i;

    // form fields
    const requiredFields = document.querySelectorAll('.form-page-1 [required]');
    const emailField = document.querySelector('.form-page-1 #email');
    const emailConfField = document.querySelector('.form-page-1 #emailconfirm');
    const phoneField = document.querySelector('.form-page-1 #phone');

    requiredFields.forEach(field => {
      if (field.value === '') {
        // test required field
        if (field.nodeName === 'SELECT') {
          let errorMsg = field.parentElement.nextElementSibling.dataset.errorMsg;
          field.parentElement.nextElementSibling.innerText = errorMsg === '' ? 'This field is required.' : errorMsg;
          field.parentElement.nextElementSibling.classList.add('show-error');
        } else {
          let errorMsg = field.nextElementSibling.dataset.errorMsg;
          field.nextElementSibling.innerText = errorMsg === '' ? 'This field is required.' : errorMsg;
          field.nextElementSibling.classList.add('show-error');
        }
        passValidation = false;
      } else if (field.nodeName === 'SELECT') {
        // hide error message for required select dropdown if value is not empty
        field.parentElement.nextElementSibling.classList.remove('show-error');
        // } else if (field.id.indexOf('name') >= 0 || field.id === 'company') {
        //   // test valid first, last, rep, and company name format
      } else if (field.id.indexOf('name') >= 0) {
        // test valid first, last, and rep name format
        if (!nameRegEx.test(field.value)) {
          field.nextElementSibling.innerText = 'Invalid format.';
          field.nextElementSibling.classList.add('show-error');
          passValidation = false;
        } else {
          field.nextElementSibling.classList.remove('show-error');
        }
      } else if (field.id.indexOf('email') >= 0) {
        // test valid email format
        if (!emailRegEx.test(field.value)) {
          field.nextElementSibling.innerText = 'Invalid email format.';
          field.nextElementSibling.classList.add('show-error');
          passValidation = false;
        } else {
          field.nextElementSibling.classList.remove('show-error');
        }
      } else if (field.id === 'address1') {
        // // test valid address format and no PO box
        // if (!addressRegEx.test(field.value)) {
        //   field.nextElementSibling.innerText = 'Invalid address format.';
        //   field.nextElementSibling.classList.add('show-error');
        //   passValidation = false;
        // } else if (pobRegEx.test(field.value)) {

        // test no PO box
        if (pobRegEx.test(field.value)) {
          field.nextElementSibling.innerText = 'No PO boxes';
          field.nextElementSibling.classList.add('show-error');
          passValidation = false;
        } else {
          field.nextElementSibling.classList.remove('show-error');
        }
      } else if (field.id === 'city') {
        // test valid city format
        if (!cityRegEx.test(field.value)) {
          field.nextElementSibling.innerText = 'Invalid city format.';
          field.nextElementSibling.classList.add('show-error');
          passValidation = false;
        } else {
          field.nextElementSibling.classList.remove('show-error');
        }
      } else if (field.id === 'zipcode') {
        // test valid zip code format
        if (!zipRegEx.test(field.value)) {
          field.nextElementSibling.innerText = 'Invalid zip format.';
          field.nextElementSibling.classList.add('show-error');
          passValidation = false;
        } else {
          field.nextElementSibling.classList.remove('show-error');
        }
      } else {
        field.nextElementSibling.classList.remove('show-error');
      }
    });

    // test email confirmation matching
    if (email.value !== '' && emailField.value.toLowerCase() !== emailConfField.value.toLowerCase()) {
      emailConfField.nextElementSibling.innerText = 'Email address must match.';
      emailConfField.nextElementSibling.classList.add('show-error');
      passValidation = false;
    }

    // test phone format
    if (!phoneRegEx.test(phoneField.value) && phoneField.value !== '') {
      phoneField.nextElementSibling.innerText = 'Invalid phone format.';
      phoneField.nextElementSibling.classList.add('show-error');
      passValidation = false;
    } else {
      phoneField.nextElementSibling.classList.remove('show-error');
    }

    const stepErrorMsg = document.querySelector('.form-page-1 .error-msg.catch-all');
    if (passValidation) {
      stepErrorMsg.classList.remove('show-error');
    } else {
      stepErrorMsg.classList.add('show-error');
    }
    return passValidation;
  }

  //---------- VALIDATE STEP TWO FORM FIELDS ----------
  function validateStepTwoFields() {
    let passValidation = true;

    const formData = new FormData(form);
    const requiredFields = ['benefits', 'roi', 'needs-met', 'tools', 'challenge', 'frequency', 'terms'];
    // test required field
    requiredFields.forEach(field => {
      let fieldValue = formData.get(field);
      let fieldError = document.querySelector(`.form-page-2 .error-msg.${field}`);
      if (fieldValue === null || fieldValue === '') {
        fieldError.innerText = 'This field is required.';
        fieldError.classList.add('show-error');
        passValidation = false;
      } else {
        fieldError.classList.remove('show-error');
      }
    });

    const stepErrorMsg = document.querySelector('.form-page-2 .error-msg.catch-all');
    if (passValidation) {
      stepErrorMsg.classList.remove('show-error');
    } else {
      stepErrorMsg.classList.add('show-error');
    }
    return passValidation;
  }

  // click handler for the next button in step one
  function stepOneNextClickHandler(event) {
    event.preventDefault();
    stepOneNextBtn.classList.add('blocked');
    if (validateStepOneFields()) {
      stepTwo.classList.add('unlocked');
      setStep('step-two');
    }
    stepOneNextBtn.classList.remove('blocked');
  }
  // click handler for the next button in step two
  function stepTwoNextClickHandler(event) {
    event.preventDefault();
    stepTwoNextBtn.classList.add('blocked');
    if (validateStepTwoFields()) {
      form.dispatchEvent(new CustomEvent('submit', { cancelable: true }));
    } else {
      stepTwoNextBtn.classList.remove('blocked');
    }
  }
  stepOneNextBtn.addEventListener('click', stepOneNextClickHandler);
  stepTwoNextBtn.addEventListener('click', stepTwoNextClickHandler);

  // reset all form fields
  function resetForm() {
    let textInputFields = document.querySelectorAll('form#mug-form input[type="text"]');
    textInputFields.forEach(field => {
      field.value = '';
    });
    let textareaFields = document.querySelectorAll('form#mug-form textarea');
    textareaFields.forEach(field => {
      field.value = '';
    });
    let selectFields = document.querySelectorAll('form#mug-form select');
    selectFields.forEach(field => {
      field.value = '';
    });
    let radioButtonInputs = document.querySelectorAll('form#mug-form input[type="radio"]');
    radioButtonInputs.forEach(field => {
      if (field.value === '') field.click();
    });
    let checkboxInputs = document.querySelectorAll('form#mug-form input[type="checkbox"]');
    checkboxInputs.forEach(field => {
      field.checked = false;
    });
  }

  // handle form submit event
  function handleSubmit(event) {
    event.preventDefault();
    const formData = new FormData(form);

    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(formData).toString()
    })
      .then(() => {
        stepThree.classList.add('unlocked');
        setStep('step-three');
        resetForm();
        stepTwoNextBtn.classList.remove('blocked');
      })
      .catch(error => alert(error));
  }
  form.addEventListener('submit', handleSubmit);
});
